<div class="scrollable-component">
	<div class="container">
		<div class="row">
			<div class="col-12">
				<cv-generic-crud-table 
					[label]="'Outgoing Events'"
					#outgoingEventsTable
					[modalSize]="ModalSize.LG"
					[tableConfig]="config"
					[params]="config"
					[model]="tableModel"
					[formBuilderConfig]="formBuilderConfig"
					[extraData]="extraData">
				</cv-generic-crud-table>
			</div>
		</div>
	</div>
</div>